import {
  TASK_STATUS_OPTIONS,
  TASK_SUBJECT_OPTIONS,
  TaskActionEnum,
  TaskStatusEnum,
} from '../task.types'

export const getAction = (type: string) => {
  let newType = ''
  switch (type) {
    case TaskActionEnum.MAKE_CALL:
      newType = 'Make a Call'
      break
    case TaskActionEnum.RATE_DRIVER:
      newType = 'Rate Driver'
      break
    case 'other':
      newType = 'Other'
      break
    default:
      return type
  }
  return newType
}

export const getSubject = (subjectStr: string) => {
  return (
    TASK_SUBJECT_OPTIONS.find((subject) => subject.value === subjectStr)
      ?.label ?? subjectStr
  )
}

export const getStatus = (statusStr?: TaskStatusEnum) => {
  return (
    TASK_STATUS_OPTIONS.find((status) => status.value === statusStr)?.label ??
    statusStr
  )
}
